import { useEffect, useState } from 'react'

export const mediaQuery = {
    sp: "max-width: 768px",
    tablet: "min-width: 768px and max-width: 1122px",
    pc: "min-width: 1122px",
};

export const UseMediaQuery = (query) => {
    const formattedQuery = `(${query})`
    const [match, setMatch] = useState(matchMedia(formattedQuery).matches)

    useEffect(() => {
        const mql = matchMedia(formattedQuery)

        if (mql.media === 'not all' || mql.media === 'invalid') {
            console.error(`useMediaQuery Error: Invalid media query`)
        }

        mql.onchange = (e) => {
            setMatch(e.matches)
        }

        return () => {
            mql.onchange = null
        }
    }, [formattedQuery, setMatch])

    return match
}